import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { increase, decrease, remove } from '../redux/cartSlice';
import { useNavigate } from 'react-router-dom';
import './CartPage.css';

function CartPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const items = useSelector((state) => Object.values(state.cart.items));
  const totalCount = useSelector((state) => state.cart.totalCount);
  const totalPrice = useSelector((state) => state.cart.totalPrice);

  return (
    <div className="cart-page">
      <h1>Your Cart</h1>
      <p>Total plants: {totalCount}</p>
      <p>Total cost: ${totalPrice.toFixed(2)}</p>

      {items.length === 0 && <p>Your cart is empty.</p>}

      <div className="cart-items">
        {items.map((plant) => (
          <div key={plant.id} className="cart-item">
            <img src={plant.thumbnail} alt={plant.name} />
            <div className="info">
              <h3>{plant.name}</h3>
              <p>Unit price: ${plant.price.toFixed(2)}</p>
              <div className="quantity-controls">
                <button onClick={() => dispatch(decrease(plant.id))} disabled={plant.quantity <= 1}>
                  -
                </button>
                <span>{plant.quantity}</span>
                <button onClick={() => dispatch(increase(plant.id))}>+</button>
              </div>
              <button className="delete-btn" onClick={() => dispatch(remove(plant.id))}>
                Delete
              </button>
            </div>
          </div>
        ))}
      </div>

      {items.length > 0 && (
        <>
          <button
            className="checkout-btn"
            onClick={() => alert('Coming Soon')}
          >
            Checkout
          </button>
          <button
            className="continue-btn"
            onClick={() => navigate('/products')}
          >
            Continue Shopping
          </button>
        </>
      )}
    </div>
  );
}

export default CartPage;
